import kebabCase from 'lodash-es/kebabCase';

/**
 * Font families supported by SDS.
 *
 * The values in this enum must match the font family name exactly as it's defined in
 * /snap-design-system/fonts/
 */
export enum FontFamily {
  AVENIR_NEXT = 'Avenir Next',
  BUENOS_AIRES = 'Buenos Aires',
  GHOST_SANS = 'Ghost Sans',
  GRAPHIK = 'Graphik',
  HELVETICA_HEADING = 'Helvetica Heading',
  INTER = 'Inter',
  NOTO_SANS_BENGALI = 'Noto Sans Bengali',
  NOTO_SANS_DEVANAGARI = 'Noto Sans Devanagari',
  NOTO_SANS_GUJARATI = 'Noto Sans Gujarati',
  NOTO_SANS_GURMUKHI = 'Noto Sans Gurmukhi',
  NOTO_SANS_JAPANESE = 'Noto Sans Japanese',
  NOTO_SANS_KANNADA = 'Noto Sans Kannada',
  NOTO_SANS_KR = 'Noto Sans KR',
  NOTO_SANS_MALAYALAM = 'Noto Sans Malayalam',
  NOTO_SANS_SC = 'Noto Sans SC',
  NOTO_SANS_TAMIL = 'Noto Sans Tamil',
  NOTO_SANS_TC = 'Noto Sans TC',
  NOTO_SANS_TELUGU = 'Noto Sans Telugu',
  PROGRAM_OT = 'Program OT',
  TAHOMA_HEADING = 'Tahoma Heading',
}

export const fontLinkIdFn = (fontFamily: FontFamily): string =>
  `sdsm-font-${kebabCase(fontFamily)}`;

// Note: the location the files are stored in is
// https://console.cloud.google.com/storage/browser/snap-design-system/fonts;tab=objects?project=snap-design-system
// But it is hosted through a proxy with CDN enabled on the marketing web load balancer
export const fontDefinitionFiles: Record<FontFamily, string> = {
  [FontFamily.GRAPHIK]: 'https://web-platform.snap.com/fonts/font.graphik.css',
  [FontFamily.AVENIR_NEXT]: 'https://web-platform.snap.com/fonts/font.avenir-next.css',
  [FontFamily.BUENOS_AIRES]: 'https://web-platform.snap.com/fonts/font.buenos-aires.css',
  [FontFamily.GHOST_SANS]: 'https://web-platform.snap.com/fonts/font.ghost-sans.css',
  [FontFamily.PROGRAM_OT]: 'https://web-platform.snap.com/fonts/font.program-ot.css',
  [FontFamily.HELVETICA_HEADING]: 'https://web-platform.snap.com/fonts/font.helvetica.css',
  [FontFamily.TAHOMA_HEADING]: 'https://web-platform.snap.com/fonts/font.tahoma.css',
  [FontFamily.NOTO_SANS_BENGALI]: 'https://web-platform.snap.com/fonts/font.noto-sans-bengali.css',
  [FontFamily.NOTO_SANS_SC]:
    'https://web-platform.snap.com/fonts/font.noto-sans-simplified-chinese.css',
  [FontFamily.NOTO_SANS_TC]:
    'https://web-platform.snap.com/fonts/font.noto-sans-traditional-chinese.css',
  [FontFamily.NOTO_SANS_DEVANAGARI]:
    'https://web-platform.snap.com/fonts/font.noto-sans-devanagari.css',
  [FontFamily.NOTO_SANS_GUJARATI]:
    'https://web-platform.snap.com/fonts/font.noto-sans-gujarati.css',
  [FontFamily.NOTO_SANS_JAPANESE]:
    'https://web-platform.snap.com/fonts/font.noto-sans-japanese.css',
  [FontFamily.NOTO_SANS_KANNADA]: 'https://web-platform.snap.com/fonts/font.noto-sans-kannada.css',
  [FontFamily.NOTO_SANS_KR]: 'https://web-platform.snap.com/fonts/font.noto-sans-korean.css',
  [FontFamily.NOTO_SANS_MALAYALAM]:
    'https://web-platform.snap.com/fonts/font.noto-sans-malayalam.css',
  [FontFamily.NOTO_SANS_GURMUKHI]:
    'https://web-platform.snap.com/fonts/font.noto-sans-gurmukhi.css',
  [FontFamily.NOTO_SANS_TAMIL]: 'https://web-platform.snap.com/fonts/font.noto-sans-tamil.css',
  [FontFamily.NOTO_SANS_TELUGU]: 'https://web-platform.snap.com/fonts/font.noto-sans-telugu.css',
  [FontFamily.INTER]: 'https://web-platform.snap.com/fonts/font.inter.css',
};
